import { type SugarEnrollment } from '@app/types'
import { Badge, type BadgeProps } from '@mantine/core'
import { type FC } from 'react'

export interface ScholarshipSubStatusBadgeProps extends Omit<BadgeProps, 'children'> {
  enrollment: SugarEnrollment
}

// The backend owns the provider-facing wording (MIQ-2540), so the value is rendered
// verbatim — broadening the denial-reason mapping needs no change here.
//
// Filled rather than light, matching the badges on the letters and provider-photo
// surfaces. Those shipped first and are what providers have been reading, so a
// badge that turns up somewhere new should look like the ones they already know.
export const ScholarshipSubStatusBadge: FC<ScholarshipSubStatusBadgeProps> = ({ enrollment, ...props }) =>
  enrollment.gapScholarshipSubStatus ? (
    <Badge
      color='blue'
      variant='filled'
      {...props}
    >
      {enrollment.gapScholarshipSubStatus}
    </Badge>
  ) : null
